import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: 'https://wip.fibrebondindustries.com:5050', // Set your base URL here
  //baseURL: "https://localhost:5050",
  baseURLPath: "https://wip.fibrebondindustries.com/backend",
  withCredentials: true
});

export default axiosInstance;